import { render, staticRenderFns } from "./pku.vue?vue&type=template&id=5de51bc6&scoped=true&"
import script from "./pku.vue?vue&type=script&lang=js&"
export * from "./pku.vue?vue&type=script&lang=js&"
import style0 from "./pku.vue?vue&type=style&index=0&id=5de51bc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de51bc6",
  null
  
)

export default component.exports